import colors from './colors.json';
import { CobaltFontFamily, CobaltTheme } from '@/jss/theme';

const headingFontFamily: CobaltFontFamily = {
	fontFamily: '"museo-sans", sans-serif',
	weights: {
		regular: 400,
		medium: 500,
		bold: 700,
	},
};

const bodyFontFamily: CobaltFontFamily = {
	fontFamily: '"museo-sans", sans-serif',
	weights: {
		regular: 400,
		medium: 500,
		bold: 700,
	},
};

const theme: CobaltTheme = {
	elevation: {
		e200: '0px 3px 5px #33333333, 0px 0px 1px #3333334D',
		e400: '0px 10px 18px #33333326, 0px 0px 1px #3333334D',
	},

	colors: {
		...colors,

		/* ----------------------------------------------------------- */
		/* Non-bootstrap available colors */
		/* ----------------------------------------------------------- */
		background: colors.n50,
		border: colors.n100,
		overlay: '#333333B2',
	},

	fonts: {
		display1: {
			fontSize: '5.8rem',
			lineHeight: '6.4rem',
		},
		display2: {
			fontSize: '5.0rem',
			lineHeight: '5.6rem',
		},
		display3: {
			fontSize: '4.2rem',
			lineHeight: '4.8rem',
		},
		display6: {
			fontSize: '3.6rem',
			lineHeight: '4.0rem',
		},
		h1: {
			default: {
				fontSize: '3.2rem',
				lineHeight: '4.0rem',
			},
			mobile: {
				fontSize: '2.9rem',
				lineHeight: '3.2rem',
			},
		},
		h2: {
			default: {
				fontSize: '2.9rem',
				lineHeight: '3.2rem',
			},
			mobile: {
				fontSize: '2.4rem',
				lineHeight: '2.8rem',
			},
		},
		h3: {
			default: {
				fontSize: '2.4rem',
				lineHeight: '2.8rem',
			},
			mobile: {
				fontSize: '2.0rem',
				lineHeight: '2.4rem',
			},
		},
		h4: {
			default: {
				fontSize: '2.0rem',
				lineHeight: '2.4rem',
			},
			mobile: {
				fontSize: '1.6rem',
				lineHeight: '2.0rem',
			},
		},
		h5: {
			default: {
				fontSize: '1.6rem',
				lineHeight: '2.4rem',
			},
			mobile: {
				fontSize: '1.4rem',
				lineHeight: '1.6rem',
			},
		},
		h6: {
			default: {
				fontSize: '1.4rem',
				lineHeight: '2.0rem',
				letterSpacing: '-0.02em',
			},
			mobile: {
				fontSize: '1.2rem',
				lineHeight: '1.6rem',
			},
		},
		default: {
			fontSize: '1.4rem',
			lineHeight: '2rem',
		},
		large: {
			fontSize: '1.6rem',
			lineHeight: '2.4rem',
		},
		small: {
			fontSize: '1.2rem',
			lineHeight: '1.6rem',
		},
		xlarge: {
			fontSize: '1.8rem',
			lineHeight: '2.8rem',
		},

		headingNormal: {
			fontFamily: headingFontFamily.fontFamily,
			fontWeight: headingFontFamily.weights.regular,
		},
		headingBold: {
			fontFamily: headingFontFamily.fontFamily,
			fontWeight: headingFontFamily.weights.bold,
		},

		bodyNormal: {
			fontFamily: bodyFontFamily.fontFamily,
			fontWeight: bodyFontFamily.weights.regular,
		},
		bodyMedium: {
			fontFamily: bodyFontFamily.fontFamily,
			fontWeight: bodyFontFamily.weights.medium,
		},
		bodyBold: {
			fontFamily: bodyFontFamily.fontFamily,
			fontWeight: bodyFontFamily.weights.bold,
		},
	},
};

export default theme;
